import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCoin = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1.07347 12.5916C-0.357822 11.1603 -0.357822 8.83971 1.07347 7.40843L7.40842 1.07347C8.83971 -0.357822 11.1603 -0.357822 12.5916 1.07347L18.9265 7.40842C20.3578 8.83971 20.3578 11.1603 18.9265 12.5916L12.5916 18.9265C11.1603 20.3578 8.83971 20.3578 7.40843 18.9265L1.07347 12.5916Z",
			fill: "#FFD180"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_4578_26229",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 20,
			height: 20,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M1.74296 12.3972C0.419015 11.0733 0.419015 8.92673 1.74296 7.60279L7.60279 1.74296C8.92673 0.419015 11.0733 0.419015 12.3972 1.74296L18.257 7.60279C19.581 8.92673 19.581 11.0733 18.257 12.3972L12.3972 18.257C11.0733 19.581 8.92673 19.581 7.60279 18.257L1.74296 12.3972Z",
				fill: "#FECC06"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_4578_26229)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 19.2656,
				y: -1.97852,
				width: 6.66667,
				height: 29.3333,
				transform: "rotate(45 19.2656 -1.97852)",
				fill: "white"
			}), /* @__PURE__ */ _jsx("rect", {
				x: 15.4922,
				y: -5.25,
				width: 3.33333,
				height: 29.3333,
				transform: "rotate(45 15.4922 -5.25)",
				fill: "white"
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.01659 11.5489C3.16114 10.6935 3.16114 9.30652 4.01659 8.45106L8.45106 4.01659C9.30652 3.16114 10.6935 3.16114 11.5489 4.01659L15.9834 8.45106C16.8389 9.30652 16.8389 10.6935 15.9834 11.5489L11.5489 15.9834C10.6935 16.8389 9.30652 16.8389 8.45106 15.9834L4.01659 11.5489Z",
			fill: "#FFD180",
			stroke: "#F8AA30",
			strokeWidth: .75
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask1_4578_26229",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 3,
			y: 3,
			width: 14,
			height: 14,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M4.01659 11.5489C3.16114 10.6935 3.16114 9.30652 4.01659 8.45106L8.45106 4.01659C9.30652 3.16114 10.6935 3.16114 11.5489 4.01659L15.9834 8.45106C16.8389 9.30652 16.8389 10.6935 15.9834 11.5489L11.5489 15.9834C10.6935 16.8389 9.30652 16.8389 8.45106 15.9834L4.01659 11.5489Z",
				fill: "#EE9F07",
				stroke: "#D88D1E",
				strokeWidth: .75
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask1_4578_26229)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M25.0001 19.2492L12.3751 6.74917L11.25 6.25L8.125 9.375L6.25 11.25L7.50006 12.9992L20.5001 25.6242L25.0001 19.2492Z",
				fill: "#F8AA30"
			})
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask2_4578_26229",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 6,
			y: 6,
			width: 10,
			height: 9,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M7.92559 6.8575V13H6.42934V6.8575H7.92559ZM13.3849 14.05L12.5974 12.9912C12.3641 13.0379 12.1366 13.0613 11.9149 13.0613C11.3374 13.0613 10.8066 12.9271 10.3224 12.6587C9.84407 12.3904 9.46199 12.0171 9.17616 11.5387C8.89616 11.0546 8.75616 10.5121 8.75616 9.91125C8.75616 9.31042 8.89616 8.77083 9.17616 8.2925C9.46199 7.81417 9.84407 7.44083 10.3224 7.1725C10.8066 6.90417 11.3374 6.77 11.9149 6.77C12.4924 6.77 13.0203 6.90417 13.4987 7.1725C13.9828 7.44083 14.362 7.81417 14.6362 8.2925C14.9162 8.77083 15.0562 9.31042 15.0562 9.91125C15.0562 10.4362 14.9482 10.9175 14.7324 11.355C14.5224 11.7867 14.2278 12.1454 13.8487 12.4312L15.1962 14.05H13.3849ZM10.2874 9.91125C10.2874 10.4537 10.4332 10.8883 10.7249 11.215C11.0224 11.5358 11.4191 11.6962 11.9149 11.6962C12.4049 11.6962 12.7957 11.5329 13.0874 11.2062C13.3849 10.8796 13.5337 10.4479 13.5337 9.91125C13.5337 9.36875 13.3849 8.93708 13.0874 8.61625C12.7957 8.28958 12.4049 8.12625 11.9149 8.12625C11.4191 8.12625 11.0224 8.28667 10.7249 8.6075C10.4332 8.92833 10.2874 9.36292 10.2874 9.91125Z",
				fill: "black"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask2_4578_26229)",
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 19.2656,
				y: -1.97852,
				width: 7.57516,
				height: 29.3333,
				transform: "rotate(45 19.2656 -1.97852)",
				fill: "white"
			}), /* @__PURE__ */ _jsx("rect", {
				opacity: .8,
				x: 15.4922,
				y: -5.25,
				width: 5.13186,
				height: 29.3333,
				transform: "rotate(45 15.4922 -5.25)",
				fill: "white"
			})]
		})
	]
});
export default SvgCoin;
